// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3JieA","inputWrap":"styles_inputWrap__RgzqM","input":"styles_input__3giom"};